export const checkPermissions = (requiredPermissions, permissions) =>
  requiredPermissions.map((item) => permissions.indexOf(item)).indexOf(-1) ===
  -1;
